import { useDispatch, useSelector } from "react-redux";
import {  ChangeAdditional, ChangePrize, ChangeRate, ChangeShift, changeValueStaff } from "../../Reducer/StaffSlice";
import { useState } from "react";

function StaffManager() {
    const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)

    const Period = useSelector(state => state.PeriodSlice.Period)

    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)    

    const [CancelTouch, setCancelTouch] = useState(false)

    const dispatch = useDispatch()    

    return(
        <div
        className="StaffGlobalDiv"
        >
            <div
            className="StaffMainDiv"
            >
                {Period.MinDay < 14 && 
                <div
                className="DivFlex"
                >
                    <div
                    className="StaffLongDiv"
                    >
                        <div
                        className="StaffNameDiv ColoredGray"
                        >
                            Сотрудник
                        </div>
                        <div
                        className="StaffRateDiv ColoredGray"
                        >
                            Ставка
                        </div>
                        <div
                        className="StaffRateDiv ColoredGray"
                        >
                            Премия
                        </div>
                        <div
                        className="StaffRateDiv ColoredGray"
                        >
                            Часов
                        </div>
                        
                    </div>

                    <div
                    className="StaffPostDiv ColoredGray"
                    >
                        Управление
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Часов
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray LongText"
                    >
                        Сумма руб. доп. премии
                    </div>
                    <div
                    className="RevenueTotalDiv ColoredGray LongText"
                    >
                        Сумма руб. депремирования
                    </div>
                </div>
                }

                {Period.MaxDay > 15 && 
                <div
                className="DivFlex">
                    <div
                    className="StaffLongDiv"
                    >

                        <div
                        className="StaffNameDiv ColoredGray"
                        >
                            Сотрудник
                        </div>

                        <div
                        className="StaffRateDiv ColoredGray"
                        >
                            Ставка
                        </div>

                        <div
                        className="StaffRateDiv ColoredGray"
                        >
                            Премия
                        </div>

                        <div
                        className="StaffRateDiv ColoredGray"
                        >
                            Часов
                        </div>
                        
                    </div>

                    <div
                    className="StaffPostDiv Second ColoredGray"
                    >
                        Управление
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Часов
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray"
                    >
                        Сумма руб.
                    </div>

                    <div
                    className="RevenueTotalDiv ColoredGray LongText"
                    >
                        Сумма руб. доп. премии
                    </div>
                    <div
                    className="RevenueTotalDiv ColoredGray LongText"
                    >
                        Сумма руб. депремирования
                    </div>
                </div>
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 &&
                <div
                className="RevenueTotalDiv ColoredGray TotalMonth"
                >
                    {!Period.PeriodOn ? 'Итого за месяц' : 'Итого за период'}
                </div>
                }

            </div>
            {StaffSelectedCityArray.length > 0 && StaffSelectedCityArray.map((el) => 
            el.Post === "Управляющий" &&  el.Hidden !== true && (parseInt(new Date(el.created_at).getMonth() + 1) <= parseInt(SelectedMonth.MonthValue) || parseInt(new Date(el.created_at).getFullYear()) < parseInt(SelectedMonth.YearValue)) &&
                <div
                key={el.id}
                className="StaffMainDiv"
                >
                    {Period.MinDay < 14 && 
                    <div
                    className="StaffLongDiv"
                    >
                        <input
                        className="StaffNameInput"
                        id={'StaffNameInput' + el.id}
                        value={el.Deleted === 'false' ? el.FIO : el.FIO + ' удален ' + el.Deleted}
                        onChange={(() => {
                            return null;  
                        })}
                        />
                            
                        <input
                        className="StaffRateInput"
                        id={'StaffRateInput' + el.id}
                        value={el.Rate}
                        type="number"
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('StaffRateInput' + el.id).focus()
                        })}
                        onFocus={(() =>{
                            document.getElementById('StaffRateInput' + el.id).classList.add('Selected')
                        })}
                        onBlur={(() => {
                            document.getElementById('StaffRateInput' + el.id).classList.remove('Selected')
                        })}
                        onChange={((e) => {
                        if(SelectedMonth.BlockEdit !== true)
                            if(e.target.value !== '' && e.target.value > -1)
                            {
                            dispatch(ChangeRate({id: el.id, Value: e.target.value, Type: 'FirstRate'}))
                            }
                            else
                            {
                            dispatch(ChangeRate({id: el.id, Value: 0, Type: 'FirstRate'}))
                            }
                                
                        })}
                        />

                        <input
                        className="StaffRateInput"
                        id={'StaffPrizeInput' + el.id}
                        value={el.Prize}
                        type="number"
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('StaffPrizeInput' + el.id).focus()
                        })}
                        onFocus={(() =>{
                            document.getElementById('StaffPrizeInput' + el.id).classList.add('Selected')
                        })}
                        onBlur={(() => {
                            document.getElementById('StaffPrizeInput' + el.id).classList.remove('Selected')
                        })}
                        onChange={((e) => {
                        if(SelectedMonth.BlockEdit !== true)
                            if(e.target.value !== '' && e.target.value > -1)
                            {
                            dispatch(ChangePrize({id: el.id, Value: e.target.value, Type: 'FirstPrize'}))
                            }
                            else
                            {
                            dispatch(ChangePrize({id: el.id, Value: 0, Type: 'FirstPrize'}))
                            }
                                
                        })}
                        />

                        <input
                        className="StaffRateInput"
                        id={'StaffShiftInput' + el.id}
                        value={el.Shift}
                        type="number"
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={(() => {
                            if(!CancelTouch)
                                document.getElementById('StaffShiftInput' + el.id).focus()
                        })}
                        onFocus={(() =>{
                            document.getElementById('StaffShiftInput' + el.id).classList.add('Selected')
                        })}
                        onBlur={(() => {
                            document.getElementById('StaffShiftInput' + el.id).classList.remove('Selected')
                        })}
                        onChange={((e) => {
                        if(SelectedMonth.BlockEdit !== true)
                            if(e.target.value !== '' && e.target.value > -1)
                            {
                            dispatch(ChangeShift({id: el.id, Value: e.target.value, Type: 'FirstShift'}))
                            }
                            else
                            {
                            dispatch(ChangeShift({id: el.id, Value: 0, Type: 'FirstShift'}))
                            }
                                
                        })}
                        />
                            
                    </div>
                    }
                        {el.Hours.length > 2 && el.Hours.map((a) => 
                            a.id < 15 && a.id > Period.MinDay && a.id < Period.MaxDay &&
                            <input
                            key={a.id}
                            className="inputRevenue"
                            id={'inputRevenue' + a.id + ' ' + el.id}
                            type="number"
                            tabIndex={0}
                            value={a.Value}
                            data-value={a.Value}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={(() => {
                                if(!CancelTouch)
                                    document.getElementById('inputRevenue' + a.id + ' ' + el.id).focus()
                            })}
                            onFocus={(() =>{
                                document.getElementById('DateDivRevenue' + a.id).classList.add('Select')
                                document.getElementById('StaffNameInput' + el.id).classList.add('Select')
                                document.getElementById('inputRevenue' + a.id + ' ' + el.id).classList.add('Selected')
                            })}
                            onBlur={(() => {
                                document.getElementById('DateDivRevenue' + a.id).classList.remove('Select')
                                document.getElementById('StaffNameInput' + el.id).classList.remove('Select')
                                document.getElementById('inputRevenue' + a.id + ' ' + el.id).classList.remove('Selected')
                            })}
                            onChange={((e) => {
                            if(SelectedMonth.BlockEdit !== true)
                                if(e.target.value !== '' && e.target.value > -1)
                                {
                                    dispatch(changeValueStaff({idStaff: el.id, idValue: a.id, Value: parseFloat(e.target.value), MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                                }
                                else
                                {
                                    dispatch(changeValueStaff({idStaff: el.id, idValue: a.id, Value: 0, MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                                }
                                
                            })}
                            />
                        )}
                            {Period.MinDay < 14 && 
                            <div
                            className="DivFlex"
                            >

                                <div
                                className="RevenueTotalDiv"
                                >
                                    {el.FirstHour}
                                </div>
                                

                                <div
                                className="RevenueTotalDiv"
                                >
                                    {parseFloat(parseFloat(((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour)) + parseFloat(el.FirstBonus.Value) - parseFloat(el.FirstFine.Value)).toFixed(2).replace('.', ',') + ' руб.'} 
                                </div>
                                

                                <input
                                className="StaffDopInput"
                                id={'StaffFirstBonusInput' + el.id}
                                type="number"
                                value={el.FirstBonus.Value}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(() => {
                                    if(!CancelTouch)
                                        document.getElementById('StaffFirstBonusInput' + el.id).focus()
                                })}
                                onFocus={(() =>{
                                    document.getElementById('StaffFirstBonusInput' + el.id).classList.add('Selected')
                                })}
                                onBlur={(() => {
                                    document.getElementById('StaffFirstBonusInput' + el.id).classList.remove('Selected')
                                })}
                                onChange={((e) => {
                                    if(SelectedMonth.BlockEdit !== true)
                                        if(e.target.value !== '' && e.target.value > -1)
                                        {
                                        dispatch(ChangeAdditional({id: el.id, Type: 'FirstBonus', Value: parseFloat(e.target.value)}))
                                        }
                                        else
                                        {
                                        dispatch(ChangeAdditional({id: el.id, Type: 'FirstBonus', Value: 0}))
                                        }
                                })}
                                />
                                

                                <input
                                className="StaffDopInput"
                                id={'StaffFirstFineInput' + el.id}
                                type="number"
                                value={el.FirstFine.Value}
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(() => {
                                    if(!CancelTouch)
                                        document.getElementById('StaffFirstFineInput' + el.id).focus()
                                })}
                                onFocus={(() =>{
                                    document.getElementById('StaffFirstFineInput' + el.id).classList.add('Selected')
                                })}
                                onBlur={(() => {
                                    document.getElementById('StaffFirstFineInput' + el.id).classList.remove('Selected')
                                })}
                                onChange={((e) => {
                                    if(SelectedMonth.BlockEdit !== true)
                                        if(e.target.value !== '' && e.target.value > -1)
                                        {
                                        dispatch(ChangeAdditional({id: el.id, Type: 'FirstFine', Value: parseFloat(e.target.value)}))
                                        }
                                        else
                                        {
                                        dispatch(ChangeAdditional({id: el.id, Type: 'FirstFine', Value: 0}))
                                        }
                                })}
                                />
                                
                            </div>
                            }
                            
                            {Period.MaxDay > 15 &&
                            <div
                            className="StaffLongDiv"
                            >
                                <input
                                className="StaffNameInput"
                                id={'SecondStaffNameInput' + el.id}
                                value={el.Deleted === 'false' ? el.FIO : el.FIO + ' удален ' + el.Deleted}
                                onChange={(() => {
                                    return null;  
                                })}
                                />
                                    
                                <input
                                className="StaffRateInput"
                                id={'SecondStaffRateInput' + el.id}
                                value={el.SecondRate}
                                type="number"
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(() => {
                                    if(!CancelTouch)
                                        document.getElementById('SecondStaffRateInput' + el.id).focus()
                                })}
                                onFocus={(() =>{
                                    document.getElementById('SecondStaffRateInput' + el.id).classList.add('Selected')
                                })}
                                onBlur={(() => {
                                    document.getElementById('SecondStaffRateInput' + el.id).classList.remove('Selected')
                                })}
                                onChange={((e) => {
                                if(SelectedMonth.BlockEdit !== true)
                                    if(e.target.value !== '' && e.target.value > -1)
                                    {
                                    dispatch(ChangeRate({id: el.id, Value: e.target.value, Type: 'SecondRate'}))
                                    }
                                    else
                                    {
                                    dispatch(ChangeRate({id: el.id, Value: 0, Type: 'SecondRate'}))
                                    }
                                        
                                })}
                                />

                                <input
                                className="StaffRateInput"
                                id={'SecondStaffPrizeInput' + el.id}
                                value={el.SecondPrize}
                                type="number"
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(() => {
                                    if(!CancelTouch)
                                        document.getElementById('SecondStaffPrizeInput' + el.id).focus()
                                })}
                                onFocus={(() =>{
                                    document.getElementById('SecondStaffPrizeInput' + el.id).classList.add('Selected')
                                })}
                                onBlur={(() => {
                                    document.getElementById('SecondStaffPrizeInput' + el.id).classList.remove('Selected')
                                })}
                                onChange={((e) => {
                                if(SelectedMonth.BlockEdit !== true)
                                    if(e.target.value !== '' && e.target.value > -1)
                                    {
                                    dispatch(ChangePrize({id: el.id, Value: e.target.value, Type: 'SecondPrize'}))
                                    }
                                    else
                                    {
                                    dispatch(ChangePrize({id: el.id, Value: 0, Type: 'SecondPrize'}))
                                    }
                                        
                                })}
                                />

                                <input
                                className="StaffRateInput"
                                id={'SecondStaffShiftInput' + el.id}
                                value={el.SecondShift}
                                type="number"
                                onTouchStart={() => {
                                    setCancelTouch(false)
                                }}
                                onTouchMove={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchCancel={() => {
                                    setCancelTouch(true)
                                }}
                                onTouchEnd={(() => {
                                    if(!CancelTouch)
                                        document.getElementById('SecondStaffShiftInput' + el.id).focus()
                                })}
                                onFocus={(() =>{
                                    document.getElementById('SecondStaffShiftInput' + el.id).classList.add('Selected')
                                })}
                                onBlur={(() => {
                                    document.getElementById('SecondStaffShiftInput' + el.id).classList.remove('Selected')
                                })}
                                onChange={((e) => {
                                if(SelectedMonth.BlockEdit !== true)
                                    if(e.target.value !== '' && e.target.value > -1)
                                    {
                                    dispatch(ChangeShift({id: el.id, Value: e.target.value, Type: 'SecondShift'}))
                                    }
                                    else
                                    {
                                    dispatch(ChangeShift({id: el.id, Value: 0, Type: 'SecondShift'}))
                                    }
                                        
                                })}
                                />
                                    
                            </div>
                            }

                                {el.Hours.length > 2 && el.Hours.map((a) => 
                                    a.id > 14 && a.id > Period.MinDay && a.id < Period.MaxDay &&
                                    <input
                                    key={a.id}
                                    className="inputRevenue"
                                    id={'inputRevenue' + a.id + ' ' + el.id}
                                    type="number"
                                    tabIndex={0}
                                    value={a.Value}
                                    data-value={a.Value}
                                    onTouchStart={() => {
                                        setCancelTouch(false)
                                    }}
                                    onTouchMove={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchCancel={() => {
                                        setCancelTouch(true)
                                    }}
                                    onTouchEnd={(() => {
                                        if(!CancelTouch)
                                            document.getElementById('inputRevenue' + a.id + ' ' + el.id).focus()
                                    })}
                                    onFocus={(() =>{
                                        document.getElementById('DateDivRevenue' + a.id).classList.add('Select')
                                        document.getElementById('SecondStaffNameInput' + el.id).classList.add('Select')
                                        document.getElementById('inputRevenue' + a.id + ' ' + el.id).classList.add('Selected')
                                    })}
                                    onBlur={(() => {
                                        document.getElementById('DateDivRevenue' + a.id).classList.remove('Select')
                                        document.getElementById('SecondStaffNameInput' + el.id).classList.remove('Select')
                                        document.getElementById('inputRevenue' + a.id + ' ' + el.id).classList.remove('Selected')
                                    })}
                                    onChange={((e) => {
                                    if(SelectedMonth.BlockEdit !== true)
                                        if(e.target.value !== '' && e.target.value > -1)
                                        {
                                            dispatch(changeValueStaff({idStaff: el.id, idValue: a.id, Value: parseFloat(e.target.value), MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                                        }
                                        else
                                        {
                                            dispatch(changeValueStaff({idStaff: el.id, idValue: a.id, Value: 0, MinDay: Period.MinDay, MaxDay: Period.MaxDay}))
                                        }
                                        
                                    })}
                                    />
                                )}

                        {Period.MaxDay > 15 && 
                        <div
                        className="DivFlex"
                        >  
                            <div
                            className="RevenueTotalDiv"
                            >
                                {el.SecondHour}
                            </div>
                            
                            <div
                            className="RevenueTotalDiv"
                            >
                                {parseFloat(parseFloat(((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) - parseFloat(el.SecondFine.Value)).toFixed(2).replace('.', ',') + ' руб.'} 
                            </div>
                            
                            
                            <input
                            className="StaffDopInput"
                            id={'StaffSecondBonusInput' + el.id}
                            type="number"
                            value={el.SecondBonus.Value}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={(() => {
                                if(!CancelTouch)
                                    document.getElementById('StaffSecondBonusInput' + el.id).focus()
                            })}
                            onFocus={(() =>{
                                document.getElementById('StaffSecondBonusInput' + el.id).classList.add('Selected')
                            })}
                            onBlur={(() => {
                                document.getElementById('StaffSecondBonusInput' + el.id).classList.remove('Selected')
                            })}
                            onChange={((e) => {
                                if(SelectedMonth.BlockEdit !== true)
                                    if(e.target.value !== '' && e.target.value > -1)
                                    {
                                    dispatch(ChangeAdditional({id: el.id, Type: 'SecondBonus', Value: parseFloat(e.target.value)}))
                                    }
                                    else
                                    {
                                    dispatch(ChangeAdditional({id: el.id, Type: 'SecondBonus', Value: 0}))
                                    }
                            })}
                            />
                            
                            
                            <input
                            className="StaffDopInput"
                            id={'StaffSecondFineInput' + el.id}
                            type="number"
                            value={el.SecondFine.Value}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={(() => {
                                if(!CancelTouch)
                                    document.getElementById('StaffSecondFineInput' + el.id).focus()
                            })}
                            onFocus={(() =>{
                                document.getElementById('StaffSecondFineInput' + el.id).classList.add('Selected')
                            })}
                            onBlur={(() => {
                                document.getElementById('StaffSecondFineInput' + el.id).classList.remove('Selected')
                            })}
                            onChange={((e) => {
                                if(SelectedMonth.BlockEdit !== true)
                                    if(e.target.value !== '' && e.target.value > -1)
                                    {
                                    dispatch(ChangeAdditional({id: el.id, Type: 'SecondFine', Value: parseFloat(e.target.value)}))
                                    }
                                    else
                                    {
                                    dispatch(ChangeAdditional({id: el.id, Type: 'SecondFine', Value: 0}))
                                    }
                            })}
                            />
                        </div> 
                        }
                        
                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 &&
                        <div
                        className="RevenueTotalDiv"
                        >
                            {parseFloat(parseFloat((parseFloat((el.Rate / el.Shift) * el.FirstHour) + parseFloat((el.Prize / el.Shift) * el.FirstHour) + parseFloat((el.SecondRate / el.SecondShift) * el.SecondHour) + parseFloat((el.SecondPrize / el.SecondShift) * el.SecondHour)) + parseFloat(el.SecondBonus.Value) + parseFloat(el.FirstBonus.Value)) - parseFloat(el.FirstFine.Value) - parseFloat(el.SecondFine.Value)).toFixed(2).replace('.', ',') + ' руб.'} 
                        </div>
                        }
                        
                    </div>
            )}
        </div>
    )
}

export default StaffManager;
